import { Button, ButtonGroup, Divider, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react";
import { Alert, Form, Modal, Tag } from "components";
import { API } from "config";
import { useEffect, useRef, useState } from "react";
import { Authenticate } from "screens";

export default function Attach({ data, onSuccess = () => {}, ...props }){

    const submitRef = useRef()
    const toast = useToast()
    const auth = useDisclosure()
    const [ pdf, setPdf ] = useState() 
    const [ xml, setXml ] = useState() 
    const [ number, setNumber ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ errors, setErrors ] = useState()
    
    const handleSubmit  = async () => {
        if(!pdf && !xml) return
        setLoading(true)
        setErrors(false)

        const form = new FormData()
        
        form.append('_method', 'put')
        form.append('number', number)
        if(pdf) form.append('pdf_file', pdf)
        if(xml) form.append('xml_file', xml)

        try{
            await API.post(`/fiscal/${data?.id}/attach`, form, { headers: { "Content-Type": "multipart/form-data" } })
            props.onClose()
            onSuccess()
        }catch(err){
            toast({ title: 'Não foi possível anexar agora', description: err?.response?.data?.message, status: 'warning' })
            setErrors(err?.response?.data?.errors)
        }

        setLoading(false)
    }



    useEffect(() => {
        console.log(pdf)
    }, [pdf])

    return(
    <Modal title={`Anexar nota do pedido #${data?.order?.cod}`} {...props}>
        <ModalBody fontSize="sm">
            <Stack spacing={4}>
                <Text>Atenção ao anexar a nota fiscal manualmente, este processo só pode ser feito uma vez.</Text>

                <Divider />

                <Form.Form onSubmit={auth.onOpen} submitRef={submitRef}>
                    <Form.Text required label="Número da nota:" type="number" value={number} onChange={e => setNumber(e.target.value)} isDisabled={loading} error={errors?.number} />
                    <Form.File label="PDF da nota" accept=".pdf" isDisabled={loading} onChange={setPdf} />
                    <Form.File label="XML da nota (opcional):" accept=".xml" isDisabled={loading}  />
                </Form.Form>

                <Alert>Após anexar a nota manualmente, o status desta nota fiscal mudará para <Tag size="sm" children="Gerada" colorScheme="green" /> e a solicitação será concluída.</Alert>
            </Stack>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button children="Anexar e Concluir" isLoading={loading} onClick={() => submitRef.current?.click()} isDisabled={!pdf && !xml} />
                <Button children="Cancelar" colorScheme="red" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>

        <Authenticate {...auth} onSuccess={handleSubmit} />
    </Modal>
    )
}